__webpack_require__.p = "/Learning_cards/";